export function canUserPerformAction(userRights, action) {
    if(userRights!==undefined){
        switch(action) {
            case "create":
              return userRights[0] === 1;
            case "read":
              return userRights[1] === 1;
            case "update":
              return userRights[2] === 1;
            case "delete":
              return userRights[3] === 1;
            default:
              return false;
          }
    }
  }